import React, { PureComponent } from 'react';
import hlfLogo from '@client/shared/images/hlf-logo.svg';
import Image from '@client/components/image/Image';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from './mainHeader.scss';

class MainHeader extends PureComponent {
  render() {
    return (
      <header className={styles.mainHeader}>
        <div className={styles.nonStickyHeader}>
          <ReactLink className={styles.logoLink} to="/">
            <Image src={hlfLogo} />
          </ReactLink>
        </div>
      </header>
    );
  }
}

export default MainHeader;
